export enum SignUpStatus {
  COMPLETE = 'complete',
  CURRENTLY_DUE = 'currently_due',
  IN_PROGRESS = 'in_progress',
  FAILURE = 'failure',
  NOT_STARTED = 'not_started',
  NOT_REQUIRED = 'not_required',
  UNKNOWN = 'unknown',
}
